
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gLdsO", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $eLyVQ = parcelRequire("eLyVQ");


var $cbc8g = parcelRequire("cbc8g");


var $gfIPU = parcelRequire("gfIPU");


var $irVI7 = parcelRequire("irVI7");


var $6mKj3 = parcelRequire("6mKj3");


var $lkApp = parcelRequire("lkApp");


var $aC5ZO = parcelRequire("aC5ZO");





var $hvdlr = parcelRequire("hvdlr");


var $2VZOl = parcelRequire("2VZOl");


var $hYoU4 = parcelRequire("hYoU4");


var $8KbKw = parcelRequire("8KbKw");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");





var $9VtwR = parcelRequire("9VtwR");








var $inPa6 = parcelRequire("inPa6");




//TODO dynamic configs https://product-fabric.atlassian.net/browse/MDS-1207
const $e412362ca5524ae7$var$SESSION_LIMIT = 50;
const $e412362ca5524ae7$var$TOTAL_SESSION_LIMIT = 1000;
const $e412362ca5524ae7$export$ca2b752d32a4ba83 = (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { contentId: contentId, contentMode: contentMode, contentType: contentType, participants: participants, provider: provider } = t0;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== participants || $[1] !== userId) {
        t1 = ()=>participants.get(userId ?? "unidentified");
        $[0] = participants;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    const getCurrentUser = t1;
    let t2;
    if ($[3] !== provider) {
        t2 = ()=>provider?.getParticipants().length ?? 0;
        $[3] = provider;
        $[4] = t2;
    } else t2 = $[4];
    const getTotalSessions = t2;
    let t3;
    if ($[5] !== contentMode || $[6] !== contentType) {
        t3 = ()=>[
                "blogpost",
                "page"
            ].includes(contentType) && contentMode === "view";
        $[5] = contentMode;
        $[6] = contentType;
        $[7] = t3;
    } else t3 = $[7];
    const isViewContentType = t3;
    let t4;
    if ($[8] !== contentId || $[9] !== contentType || $[10] !== createAnalyticsEvent || $[11] !== provider) {
        t4 = (currentUser, totalSessions)=>{
            const currentUserHasReachedSessionLimit = currentUser && Object.keys(currentUser.sessions).length > $e412362ca5524ae7$var$SESSION_LIMIT;
            if (currentUserHasReachedSessionLimit || totalSessions > $e412362ca5524ae7$var$TOTAL_SESSION_LIMIT) {
                provider?.destroy();
                createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        source: "presenceAvatarGroup",
                        action: "destroyConnection",
                        actionSubject: "presenceAvatarGroupConnection",
                        attributes: {
                            sessionLimitType: currentUserHasReachedSessionLimit ? "currentUser" : "totalSessions",
                            contentId: contentId,
                            contentType: contentType
                        }
                    }
                }).fire();
            }
        };
        $[8] = contentId;
        $[9] = contentType;
        $[10] = createAnalyticsEvent;
        $[11] = provider;
        $[12] = t4;
    } else t4 = $[12];
    const checkSessionLimit = t4;
    let t5;
    let t6;
    if ($[13] !== checkSessionLimit || $[14] !== getCurrentUser || $[15] !== getTotalSessions || $[16] !== isViewContentType) {
        t5 = ()=>{
            if (!isViewContentType()) return;
            checkSessionLimit(getCurrentUser(), getTotalSessions());
        };
        t6 = [
            checkSessionLimit,
            getCurrentUser,
            getTotalSessions,
            isViewContentType
        ];
        $[13] = checkSessionLimit;
        $[14] = getCurrentUser;
        $[15] = getTotalSessions;
        $[16] = isViewContentType;
        $[17] = t5;
        $[18] = t6;
    } else {
        t5 = $[17];
        t6 = $[18];
    }
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {};
        $[19] = t7;
    } else t7 = $[19];
    return t7;
};


/** @graphql agg **/ 
var $eSUdr = parcelRequire("eSUdr");


var $gKr8t = parcelRequire("gKr8t");

const $aed2f5bf61ddaaa1$export$9db34321b84dd37a = (accountIds)=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $gKr8t.getAGGClient)().query({
        query: (0, $eSUdr.default)`query fetchPresenceAGGUsersQuery($accountIds:[ID!]!){users(accountIds:$accountIds){accountId name picture}}`,
        variables: {
            accountIds: accountIds
        }
    }).then(({ data: data })=>{
        return data?.users?.filter((user)=>user?.accountId).map((user)=>({
                avatar: user.picture ?? '',
                email: '',
                name: user.name ?? '',
                userId: user.accountId || ''
            })) ?? [];
    });
};


/** @graphql cc **/ 



var $hp2SH = parcelRequire("hp2SH");

const $9cba87adb0d6c766$export$bf12d28b3016b36b = (accountIds)=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $eSUdr.default)`query fetchPresenceConfluenceUsersQuery($accountIds:[String]){confluenceUsers(accountIds:$accountIds){nodes{profilePicture{isDefault path(type:RELATIVE)}...on KnownUser{accountId}...on UnknownUser{accountId}displayName}}}`,
        variables: {
            accountIds: accountIds
        }
    }).then(({ data: data })=>{
        return data?.confluenceUsers?.nodes?.filter((user)=>user?.accountId).map((user)=>({
                avatar: user?.profilePicture?.path ?? '',
                email: '',
                isGuest: undefined,
                name: user?.displayName ?? '',
                userId: user?.accountId ?? ''
            })) ?? [];
    });
};



var $0ejZ8 = parcelRequire("0ejZ8");

const $5748c7d61e5bba21$var$MAX_FETCH_SIZE = 25;
const $5748c7d61e5bba21$export$457bc606c36b9a3f = (contentId, contentType, contentMode, activity)=>{
    const shouldCreatePresenceConnection = contentMode === 'view';
    const [{ collabEditInitialized: collabEditInitialized, collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    // presenceId is pulled from the native collab state to ensure that we have a consistent presenceId for a given contentId
    // across the collab providers that drive editor as well as presence components (telepointer and avatar colors).
    const [{ presenceId: presenceId }] = (0, $2VZOl.useNativeCollabPresenceState)();
    const { add: add, remove: remove, addTelepointerData: addTelepointerData } = (0, $lkApp.usePresenceStoreActions)();
    const participants = (0, $lkApp.useParticipants)();
    const { cloudId: cloudId, activationId: activationId, userId: userId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const { fetchAnonymousAsset: fetchAnonymousAsset } = (0, $0ejZ8.useAnonymousAsset)();
    const sessions = (0, $42omo.useRef)(new Set());
    const providerRef = (0, $42omo.useRef)(collabEditProvider);
    const presenceIdRef = (0, $42omo.useRef)(presenceId);
    // really for testing purposes
    const [isInitialized, setIsInitialized] = (0, $42omo.useState)(false);
    const [networkError, setNetworkError] = (0, $42omo.useState)(undefined);
    (0, $e412362ca5524ae7$export$ca2b752d32a4ba83)({
        contentId: contentId,
        contentType: contentType,
        contentMode: contentMode,
        participants: participants,
        provider: providerRef.current
    });
    const getUsers = (0, $42omo.useCallback)((userIds)=>{
        return isGuest || !isLoggedIn || !isLicensed ? (0, $aed2f5bf61ddaaa1$export$9db34321b84dd37a)(userIds) : (0, $9cba87adb0d6c766$export$bf12d28b3016b36b)(userIds);
    }, [
        isGuest,
        isLoggedIn,
        isLicensed
    ]);
    const fetchAnonymousAssetCallback = (0, $42omo.useCallback)(async (id)=>{
        try {
            return await fetchAnonymousAsset(id);
        } catch (error) {
            handleOnFetchError(error);
        }
        return undefined;
    }, [
        fetchAnonymousAsset
    ]);
    const getTotalParticipants = ()=>{
        const uniqueSet = new Set();
        // really just needed for current user id before socket connects, but keeping it simple and just iterate though all participants
        participants.forEach((p)=>uniqueSet.add(p.presenceId));
        // participants from connection
        providerRef.current?.getParticipants().forEach((p_0)=>uniqueSet.add(p_0.presenceId));
        return uniqueSet.size;
    };
    const handleOnFetchError = (error_0)=>{
        // want to prevent an infinite spam of api calls being made
        setNetworkError(error_0);
        (0, $7Sm4c.markErrorAsHandled)(error_0);
    };
    const handleOnPresence = (0, $42omo.useCallback)(()=>{
        const people = providerRef.current?.getParticipants().filter((p_1)=>p_1.isHydrated);
        people?.forEach((participant)=>{
            sessions.current.add(participant.sessionId);
            add(participant);
        });
        const participantSessions = people?.map((p_2)=>p_2.sessionId) ?? [];
        // getParticipants returns all active users, so need to determine which ones to remove
        sessions.current.forEach((sessionId)=>{
            if (!participantSessions.includes(sessionId)) {
                remove(sessionId);
                sessions.current.delete(sessionId);
            }
        });
    }, // don't let this depend on anything with frequent state changes to avoid unnecessary subscriptions and un-subscriptions of the event handling
    [
        add,
        remove
    ]);
    const initializeProvider = (0, $42omo.useCallback)(()=>{
        const permissionTokenRefresh = (0, $8KbKw.fetchCollabPermissionToken)(contentId, undefined);
        const documentAri = `ari:cloud:confluence:${cloudId}:${contentType}/${contentId}`;
        // In order to support deduplication of the collaborator, presenceId will be set to the userId if it exists.
        // This means that anonymous users will still rely on presenceId and not get deduplicated.
        const collaboratorPresenceId = userId ?? presenceIdRef.current;
        const provider = (0, $hvdlr.createSocketIOCollabProvider)({
            url: (0, $9VtwR.getPresenceServiceUrl)(),
            path: (0, $9VtwR.getPresenceServicePath)(cloudId, activationId),
            documentAri: documentAri,
            permissionTokenRefresh: permissionTokenRefresh,
            need404: true,
            isPresenceOnly: true,
            productInfo: {
                product: 'confluence',
                subProduct: 'team-presence'
            },
            batchProps: {
                batchSize: $5748c7d61e5bba21$var$MAX_FETCH_SIZE,
                participantsLimit: undefined,
                getUsers: getUsers,
                onError: handleOnFetchError
            },
            fetchAnonymousAsset: fetchAnonymousAssetCallback,
            presenceId: collaboratorPresenceId,
            presenceActivity: 'viewer'
        });
        // Since we moved to only creating a presence connection on view pages, we should always be a viewer
        provider.setupForPresenceOnly((0, $9VtwR.getPresenceClientId)());
        providerRef.current = provider;
        setIsInitialized(true);
    }, [
        cloudId,
        activationId,
        contentId,
        contentType,
        fetchAnonymousAssetCallback,
        getUsers,
        userId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (shouldCreatePresenceConnection) initializeProvider();
        else setIsInitialized(true);
        // When we don't have a provider and we are not creating a presence connection,
        // we should use the existing collabEditProvider, there was an edge case where this provider wasn't
        // available on the first render.
        if (!providerRef.current && collabEditProvider) providerRef.current = collabEditProvider;
        providerRef.current?.on('presence', handleOnPresence);
        providerRef.current?.on('presence:changed', handleOnPresence);
        providerRef.current?.on('telepointer', addTelepointerData);
        return ()=>{
            providerRef.current?.off('presence', handleOnPresence);
            providerRef.current?.off('presence:changed', handleOnPresence);
            providerRef.current?.off('telepointer', addTelepointerData);
            // we do not want to destroy the live connection, since we didn't create it
            if (shouldCreatePresenceConnection) providerRef.current?.destroy();
        };
    }, [
        addTelepointerData,
        collabEditProvider,
        shouldCreatePresenceConnection,
        initializeProvider,
        handleOnPresence
    ]);
    (0, $42omo.useEffect)(()=>{
        if (shouldCreatePresenceConnection || !collabEditInitialized) return;
        providerRef.current?.sendMessage({
            type: 'participant:activity',
            activity: activity
        });
    }, [
        activity,
        collabEditInitialized,
        shouldCreatePresenceConnection
    ]);
    (0, $42omo.useEffect)(()=>{
        presenceIdRef.current = presenceId;
    }, [
        presenceId
    ]);
    return {
        isInitialized: // used only for testing
        isInitialized,
        // used only for testing
        provider: providerRef.current,
        presenceId: presenceId,
        // want to return DUMMY as a default to preserve activity lookup if provider isn't available yet
        sessionId: providerRef.current?.getSessionId() ?? (0, $9VtwR.CURRENT_USER_DUMMY_SESSION_ID),
        networkError: networkError,
        totalParticipants: getTotalParticipants()
    };
};


const $509bcff20a36ae58$var$i18n = (0, $cgtv4.defineMessages)({
    anonymousUser: {
        id: "team-presence.avatar-group.anonymous-user",
        defaultMessage: "Anonymous Person"
    }
});
const $509bcff20a36ae58$export$7723f8df67e0bef7 = (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { contentId: contentId, contentMode: contentMode, contentType: contentType, activity: activity, analyticSource: analyticSource } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { sessionId: sessionId, networkError: networkError, totalParticipants: totalParticipants } = (0, $5748c7d61e5bba21$export$457bc606c36b9a3f)(contentId, contentType, contentMode, activity);
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($509bcff20a36ae58$var$i18n.anonymousUser);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== activity || $[3] !== sessionId || $[4] !== t1) {
        t2 = {
            activity: activity,
            sessionId: sessionId,
            anonymousName: t1
        };
        $[2] = activity;
        $[3] = sessionId;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const participants = (0, $lkApp.useTransformedParticipants)(t2);
    if (networkError) {
        let t3;
        if ($[6] !== networkError) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
                name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE),
                error: networkError
            });
            $[6] = networkError;
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    let t3;
    if ($[8] !== participants) {
        t3 = participants.some($509bcff20a36ae58$var$_temp);
        $[8] = participants;
        $[9] = t3;
    } else t3 = $[9];
    const nonGuestShowsDefaultProfile = t3;
    let t4;
    if ($[10] !== participants) {
        t4 = participants.some($509bcff20a36ae58$var$_temp2);
        $[10] = participants;
        $[11] = t4;
    } else t4 = $[11];
    const showsDefaultProfile = t4;
    let t5;
    if ($[12] !== nonGuestShowsDefaultProfile || $[13] !== showsDefaultProfile) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cbc8g.default), {
            data: {
                nonGuestShowsDefaultProfile: nonGuestShowsDefaultProfile,
                showsDefaultProfile: showsDefaultProfile
            }
        });
        $[12] = nonGuestShowsDefaultProfile;
        $[13] = showsDefaultProfile;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== analyticSource || $[16] !== contentId || $[17] !== contentMode || $[18] !== contentType || $[19] !== participants || $[20] !== totalParticipants) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aC5ZO.PresenceAvatarGroup), {
            contentId: contentId,
            contentMode: contentMode,
            contentType: contentType,
            analyticSource: analyticSource,
            participants: participants,
            totalParticipants: totalParticipants
        });
        $[15] = analyticSource;
        $[16] = contentId;
        $[17] = contentMode;
        $[18] = contentType;
        $[19] = participants;
        $[20] = totalParticipants;
        $[21] = t6;
    } else t6 = $[21];
    let t7;
    if ($[22] !== t6 || $[23] !== totalParticipants) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($509bcff20a36ae58$var$FlipperAnimationsWrapper, {
            flipKey: totalParticipants
        }, t6);
        $[22] = t6;
        $[23] = totalParticipants;
        $[24] = t7;
    } else t7 = $[24];
    let t8;
    if ($[25] !== t5 || $[26] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t5, t7);
        $[25] = t5;
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    return t8;
};
const $509bcff20a36ae58$var$FlipperAnimationsWrapper = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { children: children, flipKey: flipKey } = t0;
    if ((0, $6mKj3.expValEquals)("cc-motion-survey-experiment", "cohort", "experiment")) {
        let t1;
        let t2;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {
                stiffness: 200,
                damping: 28
            };
            t2 = {
                default: {
                    speed: 0.3
                }
            };
            $[0] = t1;
            $[1] = t2;
        } else {
            t1 = $[0];
            t2 = $[1];
        }
        let t3;
        if ($[2] !== children || $[3] !== flipKey) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eLyVQ.Flipper), {
                flipKey: flipKey,
                spring: t1,
                staggerConfig: t2
            }, children);
            $[2] = children;
            $[3] = flipKey;
            $[4] = t3;
        } else t3 = $[4];
        return t3;
    }
    let t1;
    if ($[5] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[5] = children;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
function $509bcff20a36ae58$var$_temp(participant) {
    return participant.src === "" && !participant.isGuest;
}
function $509bcff20a36ae58$var$_temp2(participant_0) {
    return participant_0.src === "";
}
module.exports["PagePresence"] = $509bcff20a36ae58$export$7723f8df67e0bef7;

});

parcelRegister("fh4WQ", function(module, exports) {

var $9d5GH = parcelRequire("9d5GH");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $b1ec481d92afa1cf$var$baseForOwn(object, iteratee) {
    return object && $9d5GH(object, iteratee, $d6TaN);
}
module.exports = $b1ec481d92afa1cf$var$baseForOwn;

});

parcelRegister("iawSg", function(module, exports) {

var $fh4WQ = parcelRequire("fh4WQ");


var $fKRi0 = parcelRequire("fKRi0");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $d3a2a94fdae59b54$var$baseEach = $fKRi0($fh4WQ);
module.exports = $d3a2a94fdae59b54$var$baseEach;

});

parcelRegister("fKRi0", function(module, exports) {

var $bRRFB = parcelRequire("bRRFB");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b7847d143ef17a3d$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$bRRFB(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $b7847d143ef17a3d$var$createBaseEach;

});

parcelRegister("77wHb", function(module, exports) {

var $gETEr = parcelRequire("gETEr");


var $bSxMj = parcelRequire("bSxMj");


var $hWvFC = parcelRequire("hWvFC");


var $fZxmY = parcelRequire("fZxmY");

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $52f28c800c0dec0e$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $fZxmY(collection) ? $gETEr : $bSxMj, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $hWvFC(iteratee, 2), accumulator);
    };
}
module.exports = $52f28c800c0dec0e$var$createAggregator;

});

parcelRegister("gETEr", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $c20b8cf123ccbac3$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $c20b8cf123ccbac3$var$arrayAggregator;

});

parcelRegister("bSxMj", function(module, exports) {

var $iawSg = parcelRequire("iawSg");

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $8a5ef07d195ea024$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $iawSg(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $8a5ef07d195ea024$var$baseAggregator;

});

parcelRegister("9NwnH", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");


var $ks2lK = parcelRequire("ks2lK");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $5jGZY = parcelRequire("5jGZY");

class $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd {
    constructor(step, inverted, origin){
        this.step = step;
        this.inverted = inverted;
        this.origin = origin;
    }
}
function $c4b7da7a59ba31a1$export$bced9e015fcf3afa(steps, over, transform) {
    for(let i = steps.length - 1; i >= 0; i--)transform.step(steps[i].inverted);
    for(let i = 0; i < over.length; i++)transform.step(over[i]);
    const result = [];
    for(let i = 0, mapFrom = steps.length; i < steps.length; i++){
        const mapped = steps[i].step.map(transform.mapping.slice(mapFrom));
        const movedStep = (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) ? (0, $5jGZY.mapStep)(steps, transform, i, mapped) : undefined;
        mapFrom--;
        if (mapped && !transform.maybeStep(mapped).failed) {
            // Open ticket for setMirror https://github.com/ProseMirror/prosemirror/issues/869
            // @ts-expect-error
            transform.mapping.setMirror(mapFrom, transform.steps.length - 1);
            result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(mapped, mapped.invert(transform.docs[transform.docs.length - 1]), steps[i].origin));
        }
        // If the step is a "move" step - apply the additional step
        if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) {
            if (movedStep && !transform.maybeStep(movedStep).failed) result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(movedStep, movedStep.invert(transform.docs[transform.docs.length - 1]), transform));
        }
    }
    return result;
}
// This state field accumulates changes that have to be sent to the
// central authority in the collaborating group and makes it possible
// to integrate changes made by peers into our local document. It is
// defined by the plugin, and will be available as the `collab` field
// in the resulting editor state.
class $c4b7da7a59ba31a1$var$CollabState {
    constructor(// The version number of the last update received from the central
    // authority. Starts at 0 or the value of the `version` property
    // in the option object, for the editor's value when the option
    // was enabled.
    version, // The local steps that havent been successfully sent to the
    // server yet.
    unconfirmed){
        this.version = version;
        this.unconfirmed = unconfirmed;
    }
}
function $c4b7da7a59ba31a1$var$unconfirmedFrom(transform) {
    const result = [];
    for(let i = 0; i < transform.steps.length; i++)result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(transform.steps[i], transform.steps[i].invert(transform.docs[i]), transform));
    return result;
}
const $c4b7da7a59ba31a1$var$collabKey = new (0, $ks2lK.PluginKey)('collab');
function $c4b7da7a59ba31a1$export$995d9de96d1b2e26(config = {}) {
    const conf = {
        version: config.version || 0,
        clientID: // eslint-disable-next-line eqeqeq
        // generate a temporary id as clientId when it is null or undefined
        // prefix temp-pc- indicates prosemirror-collab
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        config.clientID == null || !config.clientID ? `temp-pc-${(0, $dQl1W.v4)()}` : config.clientID
    };
    const transformUnconfirmed = config.transformUnconfirmed ?? ((steps)=>steps);
    return new (0, $ks2lK.Plugin)({
        key: $c4b7da7a59ba31a1$var$collabKey,
        state: {
            init: ()=>new $c4b7da7a59ba31a1$var$CollabState(conf.version, []),
            apply (tr, collab) {
                const newState = tr.getMeta($c4b7da7a59ba31a1$var$collabKey);
                if (newState) {
                    if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) || (0, $1oCLl.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true)) return new $c4b7da7a59ba31a1$var$CollabState(newState.version, transformUnconfirmed(newState.unconfirmed));
                    else return newState;
                }
                if (tr.docChanged) return new $c4b7da7a59ba31a1$var$CollabState(collab.version, transformUnconfirmed(collab.unconfirmed.concat($c4b7da7a59ba31a1$var$unconfirmedFrom(tr))));
                return collab;
            }
        },
        config: conf,
        // This is used to notify the history plugin to not merge steps,
        // so that the history can be rebased.
        historyPreserveItems: true
    });
}
function $c4b7da7a59ba31a1$export$5af1c9a2797f6d8e(state) {
    const tr = state.tr;
    const { version: version, unconfirmed: unconfirmed } = $c4b7da7a59ba31a1$var$collabKey.getState(state) ?? {};
    if (version === undefined || !unconfirmed) return tr.doc;
    // undo unconfirmed steps
    for(let i = unconfirmed.length - 1; i >= 0; i--)tr.step(unconfirmed[i].inverted);
    return tr.doc;
}
function $c4b7da7a59ba31a1$export$852bd88de4de2d35(state, version, // eslint-disable-next-line @typescript-eslint/no-explicit-any
docJSON, unconfirmedSteps) {
    const tr = state.tr;
    const doc = state.schema.nodeFromJSON(docJSON);
    const { from: from, to: to } = tr.selection;
    tr.replaceWith(0, state.doc.content.size, doc);
    // apply new unconfirmed steps to doc
    for(let i = 0; i < unconfirmedSteps.length; i++)tr.step(unconfirmedSteps[i]);
    const offset = 1; // offset by 1 to account for the initial replace step
    const newUnconfirmed = tr.steps.slice(offset).map((step, i)=>{
        const index = i + offset;
        const doc = tr.docs[index];
        return new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(step, step.invert(doc), tr);
    });
    // Because we are replacing the entire document from 0 to end, the selection mapping is incorrect.
    // For now, the best we can do is set the selection to the original positions. Otherwise, it will move to the end of the doc on every change.
    tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, Math.min(from, tr.doc.content.size), Math.min(to, tr.doc.content.size)));
    return tr.setMeta('addToHistory', false).setMeta($c4b7da7a59ba31a1$var$collabKey, new $c4b7da7a59ba31a1$var$CollabState(version, newUnconfirmed));
}
function $c4b7da7a59ba31a1$export$7581d8ca0d559ec6(state, steps, clientIDs, options = {}) {
    // Pushes a set of steps (received from the central authority) into
    // the editor state (which should have the collab plugin enabled).
    // Will recognize its own changes, and confirm unconfirmed steps as
    // appropriate. Remaining unconfirmed steps will be rebased over
    // remote steps.
    const collabState = $c4b7da7a59ba31a1$var$collabKey.getState(state);
    const version = (collabState?.version || 0) + steps.length;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion,  @typescript-eslint/no-explicit-any
    const ourID = $c4b7da7a59ba31a1$var$collabKey.get(state).spec.config.clientID;
    // Find out which prefix of the steps originated with us
    let ours = 0;
    // eslint-disable-next-line eqeqeq
    while(ours < clientIDs.length && clientIDs[ours] == ourID)++ours;
    let unconfirmed = collabState?.unconfirmed.slice(ours) || [];
    steps = ours ? steps.slice(ours) : steps;
    // If all steps originated with us, we're done.
    if (!steps.length) return state.tr.setMeta($c4b7da7a59ba31a1$var$collabKey, new $c4b7da7a59ba31a1$var$CollabState(version, unconfirmed));
    const nUnconfirmed = unconfirmed.length;
    const tr = state.tr;
    if (nUnconfirmed) unconfirmed = $c4b7da7a59ba31a1$export$bced9e015fcf3afa(unconfirmed, steps, tr);
    else {
        for(let i = 0; i < steps.length; i++)tr.step(steps[i]);
        unconfirmed = [];
    }
    const newCollabState = new $c4b7da7a59ba31a1$var$CollabState(version, unconfirmed);
    if (options && options.mapSelectionBackward && state.selection instanceof (0, $ks2lK.TextSelection)) {
        tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(tr.mapping.map(state.selection.anchor, -1)), tr.doc.resolve(tr.mapping.map(state.selection.head, -1))));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        tr.updated &= -2;
    }
    return tr.setMeta('rebased', nUnconfirmed).setMeta('rebasedData', {
        unconfirmedSteps: collabState?.unconfirmed.slice(ours) || [],
        remoteSteps: steps,
        stepsAfterRebase: unconfirmed,
        versionBefore: version
    }).setMeta('addToHistory', false).setMeta($c4b7da7a59ba31a1$var$collabKey, newCollabState);
}
function $c4b7da7a59ba31a1$export$4da2109e7644e6c2(state) {
    const collabState = $c4b7da7a59ba31a1$var$collabKey.getState(state);
    if (!collabState) return null;
    // eslint-disable-next-line eqeqeq
    if (collabState.unconfirmed.length == 0) return null;
    return {
        version: collabState.version,
        steps: collabState.unconfirmed.map((s)=>s.step),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
        clientID: $c4b7da7a59ba31a1$var$collabKey.get(state).spec.config.clientID,
        get origins () {
            return(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins || (// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins = collabState?.unconfirmed.map((s)=>s.origin)));
        }
    };
}
function $c4b7da7a59ba31a1$export$971539697c176258(state) {
    return $c4b7da7a59ba31a1$var$collabKey.getState(state);
}
module.exports["Rebaseable"] = $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd;
module.exports["rebaseSteps"] = $c4b7da7a59ba31a1$export$bced9e015fcf3afa;
module.exports["collab"] = $c4b7da7a59ba31a1$export$995d9de96d1b2e26;
module.exports["getDocBeforeUnconfirmedSteps"] = $c4b7da7a59ba31a1$export$5af1c9a2797f6d8e;
module.exports["syncFromAnotherSource"] = $c4b7da7a59ba31a1$export$852bd88de4de2d35;
module.exports["receiveTransaction"] = $c4b7da7a59ba31a1$export$7581d8ca0d559ec6;
module.exports["sendableSteps"] = $c4b7da7a59ba31a1$export$4da2109e7644e6c2;
module.exports["getCollabState"] = $c4b7da7a59ba31a1$export$971539697c176258;

});

parcelRegister("5jGZY", function(module, exports) {

var $jy7VG = parcelRequire("jy7VG");


var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");

// Iterate from the specified starting index down to 0
const $33dcd085767efb3e$var$findPreviousStepInverseIndex = (steps, startIndex = steps.length - 1)=>{
    for(let i = startIndex; i >= 0; i--){
        if (!(steps[i] instanceof (0, $jy7VG.AnalyticsStep))) return i;
    }
};
const $33dcd085767efb3e$export$798cdecdcbbf9755 = (steps, transform, index, mapped)=>{
    if (index < 1) return undefined;
    const previousRebaseableStepIndex = $33dcd085767efb3e$var$findPreviousStepInverseIndex(steps.map((s)=>s.step), index - 1);
    // This checks the local steps are a "move" sequence
    if (previousRebaseableStepIndex !== undefined && $33dcd085767efb3e$export$17bbdbb89ac2acbd(steps[previousRebaseableStepIndex], steps[index].step)) {
        const previousStepInverseIndex = $33dcd085767efb3e$var$findPreviousStepInverseIndex(transform.steps);
        // Creates a new step based on the "current" steps (partially through the rebase)
        if (previousStepInverseIndex !== undefined) return $33dcd085767efb3e$export$ad07b298545ed98d(mapped, transform.steps[previousStepInverseIndex], transform, previousStepInverseIndex);
    }
};
// Only consider ReplaceStep (ReplaceAroundStep do not occur for moves)
const $33dcd085767efb3e$var$isReplaceTypeStep = (step)=>step instanceof (0, $aXG5V.ReplaceStep);
const $33dcd085767efb3e$export$17bbdbb89ac2acbd = (previousRebaseableStep, currentStep)=>{
    if (// The both steps are replace
    $33dcd085767efb3e$var$isReplaceTypeStep(previousRebaseableStep.step) && $33dcd085767efb3e$var$isReplaceTypeStep(currentStep) && // The current step is a deletion
    previousRebaseableStep.step.slice.size === 0 && // The following step is an insertion with the same length that was deleted by the current step
    Math.abs(previousRebaseableStep.step.to - previousRebaseableStep.step.from) === currentStep.slice.size) {
        // Ensure we're getting the doc before our step changes so we can compare node contents
        const originStepIndex = previousRebaseableStep.origin.steps.findIndex((s)=>s === previousRebaseableStep.step);
        if (originStepIndex === -1) return false;
        const originalDoc = previousRebaseableStep.origin.docs[originStepIndex];
        if (!originalDoc) return false;
        const currentSlice = originalDoc.slice(previousRebaseableStep.step.from, previousRebaseableStep.step.to);
        // The content from the deleted + inserted slice is exactly the same (cut + paste or drag + drop)
        if (currentSlice.eq(currentStep.slice)) return true;
    }
    return false;
};
const $33dcd085767efb3e$export$ad07b298545ed98d = (mapped, previousStep, transform, previousStepIndex)=>{
    if (!$33dcd085767efb3e$var$isReplaceTypeStep(previousStep) || mapped && !$33dcd085767efb3e$var$isReplaceTypeStep(mapped) || !mapped || // Ensure previous step index is valid
    !(previousStepIndex >= 0 && previousStepIndex < transform.docs.length && typeof previousStep?.from === 'number')) return undefined;
    const newSlice = transform.docs[previousStepIndex].slice(previousStep?.from, previousStep?.to);
    const diff = $33dcd085767efb3e$var$getDiffRange(mapped.slice.content, newSlice.content);
    if (diff === undefined) return undefined;
    const start = mapped.from + diff.start;
    const offset = newSlice.content.size - mapped.slice.content.size === 0 ? diff.end - diff.start : 0;
    // If the new slice is smaller then we're doing a deletion of content - this needs
    // to be a replace step with empty content to delete content
    if (newSlice.content.size - mapped.slice.content.size < 0) return new (0, $aXG5V.ReplaceStep)(start, start + mapped.slice.content.size - newSlice.content.size, (0, $5SAOw.Slice).empty);
    // Replace the diff range with the latest content in the document (at the old position)
    return new (0, $aXG5V.ReplaceStep)(start, start + offset, transform.docs[previousStepIndex].slice(previousStep?.from + diff.start, previousStep?.from + diff.end));
};
/**
 * Get start and end diff position values for two fragments (old, new).
 * @param {Fragment} before - content that is planned to move
 * @param {Fragment} after - content that was in paragraph being deleted (updated content)
 * @returns {object} - { start, end }
 */ function $33dcd085767efb3e$var$getDiffRange(before, after) {
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffStart
    const start = before.findDiffStart(after);
    // Important: diffEnd value is {a,b} object since end pos will differ.
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffEnd
    const diffEnd = before.findDiffEnd(after);
    if (start === null || diffEnd === null) return undefined;
    // WARNING: diffEnd may be lower than diffStart.
    // If so, add overlap to get correct range.
    // https://discuss.prosemirror.net/t/overlap-handling-of-finddiffstart-and-finddiffend/2856
    const overlap = start - Math.min(diffEnd.a, diffEnd.b);
    let end = diffEnd.b;
    if (overlap > 0) end += overlap;
    return {
        start: start,
        end: end
    };
}
module.exports["mapStep"] = $33dcd085767efb3e$export$798cdecdcbbf9755;

});

parcelRegister("lgKMU", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d6607a34d68309a3$export$9542b2119eeb5eb4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2Q0Hi",
    name: "ShareAndRestrictDialogController",
    loader: async ()=>(await (parcelRequire("vRUkw"))).Controller
});
module.exports["ShareAndRestrictDialogController"] = $d6607a34d68309a3$export$9542b2119eeb5eb4;

});

parcelRegister("vRUkw", function(module, exports) {

let $05fcb6481a64a40a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $05fcb6481a64a40a$var$load("h305A"),
    $05fcb6481a64a40a$var$load("3WvvM"),
    $05fcb6481a64a40a$var$load("hz0as"),
    $05fcb6481a64a40a$var$load("8Oa5b"),
    $05fcb6481a64a40a$var$load("ehFbl"),
    $05fcb6481a64a40a$var$load("gOP9E"),
    $05fcb6481a64a40a$var$load("6wr18"),
    $05fcb6481a64a40a$var$load("kjZZD"),
    $05fcb6481a64a40a$var$load("Wowvf"),
    $05fcb6481a64a40a$var$load("ffEVr"),
    $05fcb6481a64a40a$var$load("hhss7"),
    $05fcb6481a64a40a$var$load("c4Kdp"),
    $05fcb6481a64a40a$var$load("7EorR"),
    $05fcb6481a64a40a$var$load("bunf9")
]).then(()=>parcelRequire('4adOe'));

});


//# sourceMappingURL=PagePresence.b37cee0d.js.map
